/////////////////////////////////////////////////////////////////////////

import React from 'react'
import { PDFDownloader } from './Mycontract'
import ReactToPrint from 'react-to-print'
import { BiPrinter } from 'react-icons/bi'

function Toptabs(props) {
    var data = props.data
    var value = props.value
    var userinfo = props.userinfo
    var div = props.div
    var top = props.top
    var countNum = props.countNum
    var num = props.num
    var uni = props.uni

    return (
        <div className="flex j a w100 mb10">
            <span className="est-dev-contract">{value}</span>

            <div className="flex mr10 btnTop">
                <button
                    className="next_btn_hover p10 mt10 ml10"
                    disabled={!top}
                    onClick={
                        top
                            ? function () {
                                  countNum && countNum(-1)
                              }
                            : null
                    }
                >
                    이전
                </button>

                <span className="pdf_border-box p10 mt10 ml10">
                    {value === '견적서' || value === '비용 결제내역' || (value === '개발 계약서' && uni)
                        ? '1 / 1'
                        : num + 1 + ' / 6'}
                </span>

                <button
                    className="next_btn_hover p10 mt10 ml10 mr10"
                    disabled={!top}
                    onClick={
                        top
                            ? function () {
                                  countNum && countNum(1)
                              }
                            : null
                    }
                >
                    다음
                </button>

                <div>
                    {div ? (
                        <ReactToPrint
                            trigger={function () {
                                return (
                                    <button className="pdfDownloadBTN mt10">
                                        <BiPrinter className="f20" />
                                    </button>
                                )
                            }}
                            content={function () {
                                return div
                            }}
                        />
                    ) : (
                        <PDFDownloader contract={data} userinfo={userinfo} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default Toptabs
